<template>
  <div class="scene">
    <div id="three-scene-canvas"></div>
  </div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

//import factory from "./lowpoly.gltf";

export default {
  name: 'Scene',
  data () {
    return {
      sceneCanvas: null,
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      model: null,
      clickableObjects: []
    }
  },
  mounted () {
    /* **************
       BASIC SETUP
    ************** */

    this.sceneCanvas = document.getElementById('three-scene-canvas')
    this.scene = new THREE.Scene()
    this.camera = new THREE.PerspectiveCamera(
      75,
      this.sceneCanvas.getBoundingClientRect().width / this.sceneCanvas.getBoundingClientRect().height,
      0.1,
      1000
    )
    this.camera.position.set(15, 5, 15)
    
    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      powerPreference: "high-performance"
    })
    
    this.renderer.outputEncoding = THREE.sRGBEncoding

    this.controls = new OrbitControls(this.camera, this.renderer.domElement)
    this.controls.addEventListener('change', this.animateThreeJs )

    this.renderer.setSize(this.sceneCanvas.offsetWidth, this.sceneCanvas.offsetHeight)
    this.renderer.setClearColor("#212121")
    this.renderer.shadowMap.enabled = true
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap
    this.renderer.shadowMapSoft = true
    this.renderer.shadowMap.autoUpdate = false
    this.renderer.shadowMap.needsUpdate = true
    
    this.renderer.gammaFactor = 2.2;
    this.renderer.outputEncoding = THREE.sRGBEncoding;

    this.sceneCanvas.append(this.renderer.domElement)
    
    // lighting
    let ambientLight = new THREE.AmbientLight (0xdaccff, 0.5)
    this.scene.add(ambientLight)

    let light = new THREE.PointLight(0xfc831d, 2, 60)
    light.position.set(0, 30, 0)
    light.castShadow = true;
    light.shadow.radius = 8
    light.shadow.mapSize.width = 1024
    light.shadow.mapSize.height = 1024
    light.shadow.bias = -0.0001
    this.scene.add(light)

    // Adding a cube
    //let geometry = new THREE.BoxGeometry()
    //let material = new THREE.MeshPhysicalMaterial({color: 0x00ff00})
    //let cube = new THREE.Mesh(geometry, material)
    //this.scene.add(cube)

    var loader = new GLTFLoader();
  
    let self = this;
    loader.load( './factory-3.gltf', function ( gltf ) {
      var model = gltf.scene;

      gltf.scene.traverse( function( node ) {
        if ( node.isMesh ) { 
          node.castShadow = true; 
          node.receiveShadow = true; 
          self.clickableObjects.push(node);
          
        }
      });
    

      self.scene.add(model);
      self.model = model;
      gltf.scene.position.set(0, 0, 0);
      gltf.scene.scale.set(2,2,2);
      self.animateThreeJs()

      self.renderer.domElement.addEventListener("click", onclick, true);
      var selectedObject;
      var raycaster = new THREE.Raycaster();
      function onclick() {
        var mouse = new THREE.Vector2();
        raycaster.setFromCamera(mouse, self.camera);
        var intersects = raycaster.intersectObjects(self.clickableObjects, true); //array
        if (intersects.length > 0) {
          selectedObject = intersects[0];
          // console.log(selectedObject);

          if( selectedObject.parent ){
            if( selectedObject.parent.name === 'Scene' ){
              console.log('MACHINE');
            }
          }
        }
      }
    });



    this.animateThreeJs()
    
    window.addEventListener("resize", () => {
      this.resizeCanvas()
    })
  },
  methods: {
    animateThreeJs () {
      this.renderer.render(this.scene, this.camera)
      this.renderer.shadowMap.needsUpdate = true
    },
    
    resizeCanvas () {
      this.camera.aspect = window.innerWidth / window.innerHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.animateThreeJs()
    }
  }
}
</script>
